






























































































































































































































import { Component, Vue, Watch, Provide } from "vue-property-decorator";
import { pagnition } from "@/utils/commonConfig";
import { downloadFile } from "@/utils/index";
import { PayrollCycleKind, StuffLabel } from "@/pbjs/xcommon/enum_pb";
import { getRoleOptions } from "@/request/roleList";
import { Options } from "@/request/statementOfSalary";
@Component({
  name: "SalaryReport"
})
export default class SalaryReport extends Vue {
  @Provide() private orderOptions: any = []; // lee 工单分类下拉列表
  @Provide() private searchForm: any = {
    EmployeeName: "",
    EmployeeId: "",
    UserGroupId: null,
    PayrollCycleCondition: null,
    IsNewEmployee: null
  }; // lee 搜索表单
  @Provide() private searchFormRules: any = {
    PayrollCycleCondition: [
      { required: true, message: "Pls choose", trigger: "change" }
    ]
  };
  @Provide() private labelPosition: string = "right"; // // by Hour: 1  or by Day: 0;
  @Provide() private updatedTime: any = ""; // 上次更新时间
  @Provide() private resultData: any = [];
  @Provide() private roleOptions: any = [];
  @Provide() private PayrollCycleConditionOptions: any = [
    {
      text: "salaryReport.CurrentCycle",
      id: PayrollCycleKind.PAYROLL_CYCLE_KIND_CURRENT_PERIOD
    },
    {
      text: "salaryReport.LastCycle",
      id: PayrollCycleKind.PAYROLL_CYCLE_KIND_LAST_PERIOD
    },
    {
      text: "salaryReport.CurrentMonth",
      id: PayrollCycleKind.PAYROLL_CYCLE_KIND_CURRENT_MONTH
    }
  ];
  @Provide() private IsNewEmployeeOptions: any = [
    {
      text: "v0707.Yes",
      id: StuffLabel.STUFF_LABEL_NEW_EMPLOYEE
    },
    {
      text: "v0707.No",
      id: StuffLabel.STUFF_LABEL_VETERAN_EMPLOYEE
    }
  ];
  @Provide() private token: any = "";
  @Provide() private userid: any = "";
  @Provide() private isSearchFormActionDone: boolean = false;
  @Provide() private isExportFormActionDone: boolean = false;
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0; // lee 分页参数 目前分页是自己处理的
  @Provide() private pagnition: any = pagnition;
  private getRoleListAPI() {
    getRoleOptions({
      trackId: "",
      clientId: "",
      token: this.token
    })
      .then((res: any) => {
        console.log(res, "getRoleListApi");
        switch (res.status) {
          case "success":
            this.roleOptions = res.data;
            break;
          case "code":
            this.$router.push("./login");
            break;
          case "error":
            this.$message.error(res.message);
            break;
        }
      })
      .catch((err: any) => {
        if (err.code == 16) {
          this.$router.push("./login");
        }
        console.log(err);
      });
  }
  private created() {
    this.token = localStorage.getItem("token");
    this.userid = localStorage.getItem("userid");
    this.getRoleListAPI();
  }
  // lee 搜索操作的判断
  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.getExtenList(true);
  }
  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.getExtenList(true);
  }

  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.getExtenList(true);
    }
  }

  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.getExtenList(true);
  }
  //  lee 搜索操作
  private searchFormAction() {
    this.pagerCount = 0;
    this.pageIndex = 1;
    this.isSearchFormActionDone = true;
    this.getExtenList(true);
  }
  private testSearchForm() {
    console.log(this.searchForm);
    //  日期为必选
    if (this.searchForm.PayrollCycleCondition) {
      return true;
    } else {
      this.$message.error("pls choose time limit at least!");
      return false;
    }
  }
  //  lee 导出操作
  private exportFormAction() {
    this.getExtenList(false);
  }
  private async exportFormListAction() {
    const {
      setStatementOfSalaryReq,
      dwnloadStatementOfSalary
    }: any = await import("@/request/statementOfSalary");
    // console.log(setStatementOfSalaryReq, dwnloadStatementOfSalary, "import");
    let res = await dwnloadStatementOfSalary.handleHttp(
      setStatementOfSalaryReq(this.dwGetExtenListFuc()),
      null
    );
    // console.log(typeof res, res, "dwnloadStatementOfSalary");
    this.isExportFormActionDone = res ? res.loading : false;
    if (res && res.right) {
      console.log(res, "exportFormAction");
      if (res.filechunk) {
        let bStr = atob(res.filechunk),
          n = bStr.length,
          unit8Array = new Uint8Array(n);
        while (n--) {
          unit8Array[n] = bStr.charCodeAt(n);
        }
        const blob = new Blob([unit8Array], {
          type: "application/json"
        });
        downloadFile(blob, res.filename);
      }
    }
  }
  // lee 获取列表
  private dwGetExtenListFuc() {
    let _arg: Options = {
      Page: {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      },
      UserGroupId: +this.searchForm.UserGroupId,
      PayrollCycleCondition: +this.searchForm.PayrollCycleCondition,
      IsNewEmployee: +this.searchForm.IsNewEmployee,
      EmployeeId: this.searchForm.EmployeeId,
      EmployeeName: this.searchForm.EmployeeName
    };
    console.log(_arg, "getExlist");
    return _arg;
  }
  private async getExtenListAction() {
    const {
      setStatementOfSalaryReq,
      statementOfSalaryRequest
    }: any = await import("@/request/statementOfSalary");
    // console.log(setStatementOfSalaryReq, statementOfSalaryRequest, "import");
    let res = await statementOfSalaryRequest.handleHttp(
      setStatementOfSalaryReq(this.dwGetExtenListFuc()),
      null
    );
    res.list102 = true;
    // console.log(typeof res, res, "statementOfSalaryRequest");
    this.isSearchFormActionDone = res ? res.loading : false;
    if ((res && res.right) || (res && res.list102)) {
      // console.log(typeof res, res, "statementOfSalaryRequest");
      this.resultData = res.statementofsalaryformList;
      // console.log(this.resultData, "getExtenList");
      if (res.pageout || res.total) {
        this.pagerCount = res.total ? res.total : res.pageout.total;
      }
    }
  }
  private getExtenList(type: boolean) {
    let _form: any = this.$refs["searchForm"];
    _form.validate((valid: any, obj: any) => {
      console.log(valid, _form, obj, "searchForm");
      if (valid) {
        if (this.testSearchForm()) {
          if (type) {
            // this.pageIndex = 1;
            this.isSearchFormActionDone = true;
            this.getExtenListAction();
          } else {
            this.isExportFormActionDone = true;
            this.exportFormListAction();
          }
        }
        return true;
      } else {
        console.log("error submit!!");
        this.$message.error("pls choose time limit at least!");
        if (type) {
          this.isSearchFormActionDone = false;
        } else {
          this.isExportFormActionDone = false;
        }
        return false;
      }
    });
  }
}
